import React, { useEffect, useContext, useState } from 'react'
import { Flex, Block, Logo } from '../../components/basic/layout'
import { H1, H2, H4, H5 } from '../../components/basic/text'
import { Gray_100 } from '../../constants/colors'
import { faInfoCircle } from '@fortawesome/fontawesome-free-solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { GetPaymentPlanDetails } from "../../api"
import { setPopup, setChoices } from '../../context/actions'
import { Context } from '../../context/index'
import { TopInfoBarPopup } from './components'
import { useAfterPayInjectionScript } from './hooks'

export const TopInfoBar = ({ title, description, productData }) => {
    const [state, dispatch] = useContext(Context)
    const [isAfterPayReady, setAfterPayReady] = useState(false)

    useAfterPayInjectionScript(setAfterPayReady);

    const mobile = state.resize < 1025
    //so that we can detect deep changes on state.choices
    const stringifiedState = JSON.stringify(state.choices)

    const ReturnFeatureValues = (fields, features) => {
        const fieldCostArray = []
        for (let i = 0; i < Object.keys(fields).length; i++) {
            for (let j = 0; j < features.length; j++) {
                if (features[j].featureOsr === Object.keys(fields)[i]) {
                    const fieldChosenOsr = fields[Object.keys(fields)[i]].chosenOsr
                    const fieldChosenValue = fields[Object.keys(fields)[i]].chosenValue
                    if (features[j].options && (features[j].options.length > 0)) {
                        for (let k = 0; k < features[j].options.length; k++) {
                            const isSelectedOption = fieldChosenOsr === features[j].options[k].optionOsr
                            const selectedOptionHasAdjustmentPrice = !!features[j].options[k].adjustmentPrice
                            const selectedOptionIsNotEmpty = fieldChosenValue && fieldChosenValue.length !== 0
                            if (isSelectedOption && selectedOptionIsNotEmpty && selectedOptionHasAdjustmentPrice) {
                                fieldCostArray.push(features[j].options[k].adjustmentPrice)
                            }
                        }
                    }
                }
            }
        }
        return fieldCostArray
    }

    useEffect(() => {
        const CalculatePrice = () => {
            const choiceArray = Object.values(state.choices)
            let newChoices = state.choices
            let price = 0
            for (let i = 0; i < choiceArray.length; i++) {
                let choicePrice = 0
                choicePrice += choiceArray[i].product?.productPriceDescription?.price ? choiceArray[i].product.productPriceDescription.price : 0
                newChoices[choiceArray[i].title]["basePrice"] = choicePrice
                if (choiceArray[i]?.fields && choiceArray[i]?.product?.features) {
                    const FeatureValues = ReturnFeatureValues(choiceArray[i].fields, choiceArray[i].product.features)
                    if (FeatureValues) {
                        let totalFeatureValue = 0
                        for (let j = 0; j < FeatureValues.length; j++) {
                            totalFeatureValue += FeatureValues[j]
                        }
                        choicePrice += totalFeatureValue
                        newChoices[choiceArray[i].title]["featurePrice"] = totalFeatureValue
                    }
                }
                price += choicePrice
            }
            setChoices(dispatch, newChoices)
            return price
        }
        dispatch({ type: "SET_PRICE", payload: CalculatePrice() })
    }, [stringifiedState, dispatch, state.choices])


    useEffect(() => {
        if (state.price > 0) {
            GetPaymentPlanDetails(state.price, dispatch)
        }
    }, [state.price])

    useEffect(() => {
        if(isAfterPayReady && window.jostensAfterPay?.enabled && state.price) {
            window.jostensAfterPay.showAfterPayMessage({
                amount: state.price,
                productOsr: productData?.productOsr,
                currency: productData?.currencyCode,
                containerId: '#jos-after-pay-container'
            })
        }
    }, [isAfterPayReady, state.price, productData])

    const wordingCondition =(index)=> {
        switch (true) {
        case index===0:
            return `charged at a time of order`
        case index===1:
            return `charged 30 days later`
        case index===2:
            return `charged 30 days after ${index}nd payment`  
        case index===3:
            return `charged 30 days after ${index}rd payment`
        case index >=4:
            return `charged 30 days after ${index}th payment`
        }
    }

    const handlePopupClick = (e) => {
        e.preventDefault()

        if (state.numberOfPayments <=1) {
            return false
        }

        const payload = {
            popupWidth: "calc(100% + 60px)",
            height: "100vh",
            padding: "0",
            maxHeight: "100%",
            popupTitle: <TopInfoBarPopup icon={faInfoCircle} price={state.price} payments={state.payments} wording={wordingCondition}/>
        }

        setPopup(dispatch, payload) 
    }


    return (
        <Flex border={mobile && "1px solid lightgray"} align={mobile ? "center" : "flex-start"} padding={!mobile && "15px 1.25rem 30px 1.25rem"} margin={!mobile && "0 0 40px 0"} background={Gray_100} justify="space-between">
            <Block width="50%">
                {title && (mobile ? <H4 padding={"0 0 0 10px"} >{title.toUpperCase()}</H4> : <H1>{title.toUpperCase()}</H1>)}
                {description && !mobile && <H5 margin="15px 0 0 0">{description.toUpperCase()}</H5>}
            </Block>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "right" }}>
                <a href="" onClick={handlePopupClick}>
                    <div>
                        <H2 padding={mobile && "10px 10px 10px 15px"} borderLeft={mobile ? '1px solid lightgray' : 'none'} style={{ position: "relative", float: "right" }}>${(state.price && (state.price >= 0)) ? state.price.toFixed(2) : "0.00"} ESTIMATED TOTAL</H2>
                        {state.numberOfPayments > 1 && isAfterPayReady && !window?.jostensAfterPay?.enabled && <H4 style={{ position: "relative", float: "right", clear: "both", marginTop: "16px" }}>Or {state.payments.length} interest-free payments of $ {state.payments[0]} <Logo src="/images/aprimo/J-Bug_200px.png" /> &nbsp;<FontAwesomeIcon icon={faInfoCircle} /></H4>}
                    </div>
                </a>
                <div id="jos-after-pay-container"></div>
            </div>
        </Flex>
    )
}
